import { useState } from 'react'

import { Button, Icon, Modal } from '@fairfashion/design-system'

import { TraceabilityTree } from '../../../../components/TraceabilityTree'
import { useItemTree } from '../../../../components/TraceabilityTree/hooks/useItemTree'

import { TraceabilityModalProps } from './traceability-modal.types'

export const TraceabilityModal = ({ data }: TraceabilityModalProps) => {
  const [open, setOpen] = useState(false)

  const traceabilityProps = useItemTree({
    traceability: data,
  })

  if (!data) return null

  return (
    <>
      <Button variant="text" padding="0" onClick={() => setOpen(true)}>
        <Icon name="node_tree" size={24} color="secondary" />
      </Button>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title="Árvore de Rastreamento"
        minHeight="100%"
        minWidth="100%"
        width="100%"
        height="100%"
      >
        {open && <TraceabilityTree {...traceabilityProps} />}
      </Modal>
    </>
  )
}
